import i18next from "i18next";

export function loadDefaultLanguage() {
    const defaultLanguage = localStorage.getItem("i18nextLng") || "en";
    i18next.changeLanguage(defaultLanguage);
}

export function changeLanguage(lng) {
    i18next.changeLanguage(lng);
}

export var selectedLanguage = localStorage.getItem('selectedLanguage') || 'en';

// Set About us page layout from Right-To-Left based on the selected language
export function setAboutUsPageLayoutTranslate() {
    // Update the dropdown when the language is changed
    i18next.on('languageChanged', function (lng) {
        selectedLanguage = lng;
        
        const languageDropdown = document.getElementById('languageDropdown');
        if (languageDropdown) {
            languageDropdown.textContent = lng;
        }
        
        // Update language list header if it exists (legacy support)
        const languageListHeader = document.getElementById('language-list-header');
        if (languageListHeader) {
            languageListHeader.textContent = lng;
        }
        
        document.body.style.direction = lng === 'ar' ? 'rtl' : 'ltr';
        document.body.style.textAlign = lng === 'ar' ? 'right' : 'left';
    });
    document.body.style.textAlign = selectedLanguage === 'ar' ? 'right' : 'left';
    document.body.style.direction = selectedLanguage === 'ar' ? 'rtl' : 'ltr';
    loadGoogleFont();
}

export function setupLanguage() {
    switch (selectedLanguage) {
        case 'ar':
            document.getElementById('languageDropdown').textContent = 'العربية';
            break;
        case 'en':
            document.getElementById('languageDropdown').textContent = 'English';
            break;
        case 'tr':
            document.getElementById('languageDropdown').textContent = 'Türkçe';
            break;
        default:
            document.getElementById('languageDropdown').textContent = 'English';

    }


    // Add event listeners to the new language option buttons
    document.querySelectorAll('.language-option').forEach(button => {
        const lang = button.getAttribute('data-lang');
        
        // Set active state for current language
        if (lang === selectedLanguage) {
            button.classList.add('active');
        }
        
        button.addEventListener('click', function (e) {
            e.preventDefault();
            
            // Remove active class from all buttons
            document.querySelectorAll('.language-option').forEach(btn => {
                btn.classList.remove('active');
            });
            
            // Add active class to clicked button
            this.classList.add('active');
            
            // Change the language
            const selectedLang = this.getAttribute('data-lang');
            i18next.changeLanguage(selectedLang);
            localStorage.setItem('selectedLanguage', selectedLang);
            location.reload();
        });
    });

    // Legacy support for old language-link class (if any remain)
    document.querySelectorAll('.language-link').forEach(item => {
        item.addEventListener('click', function (e) {
            e.preventDefault();
            var lang = this.getAttribute('data-lang');
            i18next.changeLanguage(lang);
            localStorage.setItem('selectedLanguage', lang);
            location.reload();
        });
    });

    // Add event listeners to the dropdown items from navbar
    document.querySelectorAll('.dropdown-item').forEach(item => {
        item.addEventListener('click', function (e) {
            e.preventDefault();
            // Change the language when a dropdown item is clicked
            var lang = this.getAttribute('lang');
            i18next.changeLanguage(lang);
            localStorage.setItem('selectedLanguage', lang);
            location.reload();
        });
    });

    // Update the dropdown when the language is changed
    i18next.on('languageChanged', function (lng) {
        const languageDropdown = document.getElementById('languageDropdown');
        if (languageDropdown) {
            languageDropdown.textContent = lng;
        }
        
        document.body.style.direction = lng === 'ar' ? 'rtl' : 'ltr';
        document.body.style.textAlign = lng === 'ar' ? 'right' : 'left';
        
        // Update sidebar pane headers if they exist
        const sidebarPaneHeaders = document.querySelectorAll('.sidebar-pane-header');
        sidebarPaneHeaders.forEach(header => {
            header.style.textAlign = lng === 'ar' ? 'right' : 'left';
        });
    });

    document.body.style.textAlign = selectedLanguage === 'ar' ? 'right' : 'left';
    document.body.style.direction = selectedLanguage === 'ar' ? 'rtl' : 'ltr';
    loadGoogleFont();
}


i18next.init({
    lng: "en",
    debug: true,
    resources: {
        en: {
            translation: {
                "title": "AY Maps For Geopolitics and Conflicts, Statistics, Analysis and Data Visualization",
                "news-header": "News and Announcements",
                "about-us": "About us",
                "control-area-radio": "Control Area",
                "events-radio": "Events",
                "left-side-pane-country-list-title": "Choose country to display on the map",
                "countries-list-header": "Countries",

                // data filter section
                "filter-header": "Data Filter",
                "display-options": "Display Options",
                "date-range" : "Date Range",
                "start-date": "Start Date:",
                "end-date": "End Date:",
                "event-type": "Event Type",
                "apply-filter-button": "Apply Filter",
                "reset-filter-button": "Reset Filter",

                "contact-us": "Contact Us",
                // About us page
                "about-us-page-title": "About Us",
                "about-us-page-header": "About Us",
                "about-us-page-info-we-provide": "Some of the information we provide:",
                "p0": "This project is part of GIS web applicatoin and geospatial analysis, provides an interactive user interface which enable the user to display information related to geopolitics and conflicts on the map",
                "p1": "We are a team of passionate individuals dedicated to providing high-quality News and geopolitic events in the middle east",
                "p2": "Our mission is to deliver accurate and unbiased data contains content, news and analysis for the readers to learn and follow uptodate events in the world",
                "p3": "With our independent team of software engineers and independent journalists and thinkers we collect and provide data and analysis without being influeced by any organization or institution.",
                "p4": "The Data contains thousnads of entries each reperesents a single event like armed clashes and Humanitarian crisis.",
                "p5": "Each entry includes: ",
                "about-us-data-filter-header": "We provide data filtering for event type and the day that event took place:",
                "p6": "In the site you can filter data according to a specific day or choose range of days to check all events occured on that day",

                // analysis & statisics page
                "overview": "Statistics Overview",
                "language-list-header": "Language"
            }
        },
        tr: {
            translation: {
                "title": "AY Maps Coğrafi Bilgi Sistemleri ve Çatışmalar İçin Haritalar, İstatistikler, Analizler ve Veri",
                "news-header": "Haberler",
                "about-us": "Hakkımızda",
                "control-area-radio": "Kontrol Alanı",
                "events-radio": "Olaylar",
                "left-side-pane-country-list-title": "Haritada gösterilecek ülkeyi seçin",
                "countries-list-header": "Ülkeler",

                // data filter section
                "filter-header": "Veri Filtreleme",
                "display-options": "Görüntüleme Seçenekleri",
                "date-range" : "Tarih Aralığı",
                "start-date": "Başlangıç Tarihi:",
                "end-date": "Bitiş Tarihi:",
                "event-type": "Olay Türü",
                "apply-filter-button": "Filtre Uygula",
                "reset-filter-button": "Filtreyi Sıfırla",

                "contact-us": "Bize Ulaşın",

                // About us page
                "about-us-page-title": "Hakkımızda",
                "about-us-page-header": "Biz kimiz?",
                "about-us-page-info-we-provide": "Sağladığımız bilgiler:",
                "p0": "Bu proje, coğrafi bilgi sistemleri web uygulamasının bir parçasıdır ve kullanıcının haritada jeopolitik ve çatışmalarla ilgili bilgileri görüntülemesini sağlayan etkileşimli bir kullanıcı arayüzü sunar.",
                "p1": "Biz, kendilerini orta doğudaki jeopolitik olayları ve haberleri yüksek kalite avantajıyla sunmaya adamış ve tutkulu kişilerden oluşan bir gurubuz.",
                "p2": "Görevimiz, okuyucuların dünyada anlık olarak gelişen olayları takip etmeleri ve öğrenmeleri için çeşitli raporlar ve haberler içeren verileri tarafsız ve net bir şekilde onlara ulaştırmaktır.",
                "p3": "Bağımsız bir şekilde faaliyet yürüten yazılım mühendisi, araştırmacı ve düşünür gruplarımız sayesinde hiçbir organizasyon ve kuruluşun etkisi altında kalmadan çeşitli veri ve analizleri toplarız.",
                "p4": "Veriler binlerce veri girişleri içerir ve her biri silahlı çatışma ve insani kriz gibi bir olayı gösterir.",
                "p5": "Veri içerikleri: ",
                "about-us-data-filter-header": "Veri filtreleme için olay türü ve olayın gerçekleştiği günü sağlıyoruz:",
                "p6": "Sitede belirli bir güne göre verileri filtreleyebilir veya o gün gerçekleşen tüm olayları kontrol etmek için gün aralığı seçebilirsiniz.",

                // analysis & statisics page
                "overview": "İstatistikler",
                "language-list-header": "Dil seçimi"

            }
        },
        ar: {
            translation: {
                "title": "AY Maps للنظم الجغرافية والصراعات: الإحصائيات والتحليل وعرض البيانات",
                "news-header": "أخر الأخبار والتطورات",
                "about-us": "حولنا",
                "control-area-radio": "مناطق السيطرة",
                "events-radio": "الأحداث",
                "left-side-pane-country-list-title": "اختر البلد لعرضه على الخريطة",
                "countries-list-header": "البلدان",

                // data filter section
                "filter-header": "تصفية البيانات",
                "display-options": "خيارات العرض",
                "date-range" : "النطاق الزمني",
                "start-date": "تاريخ البدء:",
                "end-date": "تاريخ الانتهاء:",
                "event-type": "نوع الحدث",
                "apply-filter-button": "فلترة البيانات",
                "reset-filter-button": "إعادة تعيين الفلاتر",

                "contact-us": "اتصل بنا",

                // About us page
                "about-us-page-title": "حولنا",
                "about-us-page-header": "من نحن؟",
                "about-us-page-info-we-provide": "بعض البيانات والمعلومات التي نوفرها:",
                "p0": "هذا المشروع هو جزء من موقع الكتروني شامل لتطبيق نظم المعلومات الجغرافية، يمكن المستخدم من عرض المعلومات المرتبطة بالصراعات السياسية والأحداث في بعض المناطق على خريطة تفاعلية.",
                "p1": "نحن عبارة عن فريق مستقل يعمل لإيصال الأحداث الجيوسياسية والأخبار بدقة وموضوعية للقراء والمهتمين.",
                "p2": "نهتم بتوفير تحليلات وتقارير وبيانات حول مناطق الصراع بشكل غير متحيز لأي طرف بحيث يستطيع القارئ الحصول على معلومات دقيقة وموثوقة.",
                "p3": "فريق العمل مكون من مهندسي برمجيات وصحفيين وباحثين مستقلين يعملون على جمع البيانات وتحليلها بشكل مستقل دون التأثر بأي جهة أو مؤسسة.",
                "p4": "تحتوي البيانات على آلاف المدخلات وكل مدخل يمثل حدثًا واحدًا مثل الاشتباكات المسلحة والأزمات الإنسانية.",
                "p5": "يحتوي كل مدخل على: ",
                "about-us-data-filter-header": " نوفر إمكانية تصفية البيانات لنوع الحدث واليوم الذي وقع فيه الحدث:",
                "p6": "يمكنك تصفية البيانات في الموقع حسب يوم معين أو اختيار نطاق من الأيام للتحقق من جميع الأحداث التي وقعت في ذلك اليوم.",

                // analysis & statisics page
                "overview": "نظرة عامة/إحصائات",

                "language-list-header": "اللغة"
            }
        }
    }
}, function (err, t) {
    if (err) return console.error(err);
    document.addEventListener("DOMContentLoaded", function () {
        // Translate all elements with a 'lang-translation' attribute
        i18next.changeLanguage(selectedLanguage);
        document.querySelectorAll("[lang-translation]").forEach(elem => {
            var translation = i18next.t(elem.getAttribute("lang-translation"));

            if (elem.tagName.toLowerCase() === 'title') {
                document.title = translation;
            } else {
                // Replace only the direct text node of the element
                var textNode = Array.from(elem.childNodes).find(node => node.nodeType === Node.TEXT_NODE);
                if (textNode) {
                    textNode.textContent = translation;
                }
            }
        });
    });
    // console.log("Language changed to", lng);
});

export default i18next;

export var eventTypesAr = {
    "الكل": "All",
    "قصف مدفعي/صاروخي": "Shelling/artillery/missile attack",
    "غارة جوية/طائرة بدون طيار": "Air/drone strike",
    // "غارة طائرة بدون طيار" : "Drone strike",
    "اشتباكات مسلحة": "Armed clash",
    "هجوم/عملية عسكرية": "Attack",
    "انفجارات": "Remote explosive/landmine/IED",
    "عنف ضد المدنيين": "Abduction/forced disappearance",
    "مظاهرات": "Protests/demontrations",

    // "Arrests": "Arrests",
    // "قنبلة": "Grenade",
};

export var eventTypesEn = {
    "All": "All",
    "Shelling/Artillery/Missile Attack": "Shelling/artillery/missile attack",
    "Airstrike/Drone Strike": "Air/drone strike",
    // "Drone Strike" : "Drone strike",

    "Armed Clashes": "Armed clash",
    "Attack": "Attack",
    "Remote Explosive": "Remote explosive/landmine/IED",
    "Violence against civilians": "Abduction/forced disappearance",
    "Protests": "Protests/demontrations",
    // "Arrests": "Arrests",
    // "Grenade": "Grenade",
};

export var eventTypesTr = {
    "Bütün": "All",
    "Bombardman/Topçu/Füze saldırıları": "Shelling/artillery/missile attack",
    "Hava/İHA saldırıları": "Air/drone strike",
    // "İHA Saldırısı" : "Drone strike",

    "Silahlı Çatışmalar": "Armed clash",
    "Askeri operasyonu": "Attack",
    "Uzaktan patlayıcı": "Remote explosive/landmine/IED",
    "Sivillere karşı şiddet va saldırı": "Abduction/forced disappearance",
    "Gösteriler": "Protests/demontrations",
    // "Arrests": "Arrests",
    // "El Bombası": "Grenade",
};

export function eventTypesTranslate() {
    // switch (selectedLanguage) {
    //     case 'ar':
    //         return eventTypesAr;
    //     case 'en':
    //         return eventTypesEn;
    //     case 'tr':
    //         return eventTypesTr;
    //     default:
    //         return eventTypesEn;
    // }

    // This code is shorter and better than switch case
    const languageMap = {
        'ar': eventTypesAr,
        'en': eventTypesEn,
        'tr': eventTypesTr
    };
    return languageMap[selectedLanguage];

};

export function layersTranslation() {
    const layers = {
        'en': {
            "Control Area": "Control Area",
            "events": "Events"
        },
        'ar': {
            "Control Area": "مناطق السيطرة",
            "events": "الأحداث"
        },
        'tr': {
            "Control Area": "Kontrol Alanı",
            "events": "Olaylar"
        }
    }
    return layers[selectedLanguage];
}

// const basemapLayersEn = {

//     "light": getBasemap("arcgis/light-gray").addTo(map),
//     "streets": getBasemap("arcgis/streets"),
//     "imagery": getBasemap("arcgis/imagery"),
//     "dark-gray": getBasemap("arcgis/dark-gray"),
//     "human-geography": getBasemap("arcgis/human-geography"),
//     "charted-territory": getBasemap("arcgis/charted-territory"),
//     "nova": getBasemap("arcgis/nova"),
//     "standard": getBasemap("osm/standard"),
//     "blueprint": getBasemap("osm/blueprint")
// };

// const basemapLayersAr = {

//     "خفيف": getBasemap("arcgis/light-gray").addTo(map),
//     "الشوارع": getBasemap("arcgis/streets"),
//     "صور الأقمار الصناعية": getBasemap("arcgis/imagery"),
//     "رمادي داكن": getBasemap("arcgis/dark-gray"),
//     "رسم بشري": getBasemap("arcgis/human-geography"),
//     "التقسيم الحدودي": getBasemap("arcgis/charted-territory"),
//     "نوفا": getBasemap("arcgis/nova"),
//     "قياسي": getBasemap("osm/standard"),
//     "مخطط أزرق": getBasemap("osm/blueprint"),
// };

// const basemapLayersTr = {
//     "Hafif renk": getBasemap("arcgis/light-gray").addTo(map),
//     "Sokaklar": getBasemap("arcgis/streets"),
//     "Satalite": getBasemap("arcgis/imagery"),
//     "gri-siyah": getBasemap("arcgis/dark-gray"),
//     "insan çizgi": getBasemap("arcgis/human-geography"),
//     "sınır haritası": getBasemap("arcgis/charted-territory"),
//     "nova": getBasemap("arcgis/nova"),
//     "standard": getBasemap("osm/standard"),
//     "mavi renk": getBasemap("osm/blueprint")
// };

export const baseMapLayersTranslation = {

    'en': {
        "arcgis/light-gray": "light",
        "arcgis/streets": "streets",
        "arcgis/imagery": "imagery satellite",
        "arcgis/dark-gray": "dark-gray",
        "arcgis/human-geography": "human-geography",
        "arcgis/charted-territory": "charted-territory",
        "arcgis/nova": "nova",
        "osm/standard": "standard",
        "osm/blueprint": "blueprint",
    },
    'ar': {
        "arcgis/light-gray": "خفيف",
        "arcgis/streets": "شوارع",
        "arcgis/imagery": "صور الأقمار الصناعية",
        "arcgis/dark-gray": "رمادي داكن",
        "arcgis/human-geography": "رسم بشري",
        "arcgis/charted-territory": "التقسيم الحدودي",
        "arcgis/nova": "نوفا",
        "osm/standard": "قياسي",
        "osm/blueprint": "مخطط أزرق",
    },

}

// about us page translation

export const infoWeProvideListTranslaiton = {
    "en": ["Geopolitic events", "Analysis", "Statistics", "Reports", "Maps", "News"],
    "ar": ["الأحداث الجيوسياسية", "تحليل", "إحصائيات", "تقارير", "خرائط", "أخبار"],
    "tr": ["Jeopolitik olaylar", "Analiz", "İstatistikler", "Raporlar", "Haritalar", "Haberler"]
}

export const dataEntryTranlsation = {
    "en": ["Date: When the event occured", "Event Type: The type of the event (Airstrike, clashes, violence)", "Location:  Details about geographical location where the event took place on the map(As smallest admin like neighborhood or street", "Actors: The actors involved in the event", "A brief discription about the situation and event", "Fatakities: number of fatalities at the location"],
    "ar": ["التاريخ: تاريخ وقوع الحدث", "نوع الحدث: مثل غارة جوية، اشتباكات مسلحة، أعمال عنف", "الموقع: تفاصيل حول الموقع الجغرافي الذي وقع فيه الحدث على الخريطة", "المتسبب: الفاعلين والنافذين في الحدث", "وصف موجز عن الوضع والحدث", "الضحايا: عدد القتلى أو الجرحى في الموقع"],
    "tr": ["Tarih: Olayın ne zaman meydana geldiği", "Olay Türü: Olayın türü (Hava saldırısı, çatışmalar, sivillere şiddet", "Konum: Haritadaki olayın gerçekleştiği coğrafi konum hakkında ayrıntılar (Mahalle veya sokak gibi idari birim", "Olay: Olay sorumluları", "Durum ve olay hakkında kısa bir açıklama", "Kayıb sayısı: Konumda kayıblar veya yaralıların sayısı"]
}

function loadGoogleFont() {
    var link = document.createElement('link');
    link.href = 'https://fonts.googleapis.com/css2?family=Roboto&display=swap';
    link.rel = 'stylesheet';
    document.head.appendChild(link);
    document.body.style.fontFamily = 'Roboto, sans-serif';
}


// TODO : Implement language selection when page loaded
// modal for selecting language

// document.addEventListener("DOMContentLoaded", function (event) {
//     selectedLanguage = localStorage.getItem('selectedLanguage');
//     if (selectedLanguage) {
//         i18next.changeLanguage(selectedLanguage);
//     }
//     else {
//         // Trigger modal on page load
//         var myModal = new bootstrap.Modal(document.getElementById('myModal'), {
//             backdrop: 'static',
//             keyboard: false
//         });
//         myModal.show();

//         // Handle language selection
//         document.querySelectorAll('.language-link').forEach(function (link) {
//             link.addEventListener('click', function (e) {
//                 e.preventDefault();
//                 selectedLanguage = this.getAttribute('data-lang');
//                 localStorage.setItem('selectedLanguage', selectedLanguage);
//                 i18next.changeLanguage(selectedLanguage);
//                 // Implement language selection logic here
//                 console.log('Selected language:', selectedLanguage);
//                 myModal.hide();
//                 location.reload();
//             });
//         });
//     }
// });


// Show happy Modal on the website.
const messages = {
    en: "The Asad Regim has fall and its head Bashar Al Asad escaped to unknown location",
    tr: "Esad rejimi düştü ve başkanı Beşar Esad bilinmeyen bir yere kaçtı",
    ar: "سقط نظام الأسد وهرب رئيسه بشار الأسد إلى مكان غير معروف"
};
// Function to randomly select a message from the object
function getRandomMessage() {
    const keys = Object.keys(messages);
    const randomKey = keys[Math.floor(Math.random() * keys.length)];
    return messages[randomKey];
}


// Show modal with a random happy message
export function showModal() {
    var myModal = new bootstrap.Modal(document.getElementById('myModal'), {
        backdrop: 'static',
        keyboard: false
    });
    myModal.show();


}
